import { isBrowser } from "@local/utils/src/isBrowser"

/**
 * Browser-language properties for event payloads. Returns an empty object
 * whenever the info is not retrievable (server-side, missing `navigator`,
 * or any unexpected failure) so it is safe to spread unconditionally.
 */
export const getBrowserLanguageProps = (): {
  browser_language?: string
  browser_language_and_locale?: string
} => {
  try {
    if (!isBrowser()) {
      return {}
    }

    const language = globalThis.navigator?.language
    if (!language) {
      return {}
    }

    return {
      browser_language: language.split("-")[0].toLowerCase(),
      browser_language_and_locale: language.toLowerCase(),
    }
  } catch {
    return {}
  }
}
